import { useReadChannelPlayerBaseInfo } from '@/scenarios/legacy-player/components/channel-player/hooks/use-read-channel-player-base-info';

export const useShouldHideChannelProgram = (contentId: string) => {
    const baseInfo = useReadChannelPlayerBaseInfo(contentId);
    const isNeedToHidePrograms = baseInfo?.isNeedToHidePrograms;

    return { isNeedToHidePrograms };
};
